import React, { forwardRef, useCallback } from 'react';
import clsx from 'clsx';
import { Link, useLocation } from 'react-router-dom';
import { ListItemIcon, MenuItem, Tooltip, useMediaQuery } from '@mui/material';
import { useSidebarState, useTranslate } from 'react-admin';

const ACTIVE_CLASS = 'RaMenuItemLink-active';
const ICON_CLASS = 'RaMenuItemLink-icon';

const parseTo = (to) => {
  if (typeof to === 'string') {
    const q = to.indexOf('?');
    if (q === -1) return { pathname: to, search: '' };
    return { pathname: to.slice(0, q), search: to.slice(q) };
  }
  return {
    pathname: to?.pathname || '',
    search: to?.search || '',
  };
};

/**
 * React Admin MenuItemLink, ama:
 * - query string match'i bozmaz (/sales?last=100 → seçili olur)
 * - end / isActive ile /events-v2 vs /events-v2/create ayrılır
 */
const SidebarMenuLink = forwardRef(function SidebarMenuLink(props, ref) {
  const {
    className,
    primaryText,
    leftIcon,
    onClick,
    to,
    end = false,
    isActive: isActiveProp,
    style,
    ...rest
  } = props;

  const translate = useTranslate();
  const location = useLocation();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const [open, setOpen] = useSidebarState();
  const resolved = parseTo(to);

  const active =
    typeof isActiveProp === 'function'
      ? !!isActiveProp(location.pathname, location)
      : end
        ? location.pathname === resolved.pathname
        : location.pathname === resolved.pathname ||
          location.pathname.startsWith(`${resolved.pathname}/`);

  const handleClick = useCallback(
    (e) => {
      if (isSmall) setOpen(false);
      onClick?.(e);
    },
    [isSmall, onClick, setOpen],
  );

  const label =
    typeof primaryText === 'string' ? translate(primaryText, { _: primaryText }) : primaryText;

  const item = (
    <MenuItem
      className={clsx(className, 'RaMenuItemLink-root', {
        [ACTIVE_CLASS]: active,
      })}
      component={Link}
      ref={ref}
      tabIndex={0}
      style={style}
      {...rest}
      to={resolved}
      onClick={handleClick}
    >
      {leftIcon ? (
        <ListItemIcon className={ICON_CLASS} sx={{ minWidth: 40 }}>
          {leftIcon}
        </ListItemIcon>
      ) : null}
      {open ? label : null}
    </MenuItem>
  );

  if (open) return item;

  return (
    <Tooltip title={label || ''} placement="right">
      {item}
    </Tooltip>
  );
});

export default SidebarMenuLink;
